function loadGoogleScript() {
    return new Promise((resolve, reject) => {
        if (document.getElementById('google-gsi-script')) { resolve(); return; }
        const script = document.createElement('script');
        script.id = 'google-gsi-script';
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function initAndPrompt(clientId, resolve, reject) {
    window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
            if (response && response.credential) {
                resolve(response.credential);
            } else {
                resolve(null);
            }
        },
        auto_select: false,
        cancel_on_tap_outside: true
    });
    window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            window.google.accounts.oauth2.initTokenClient({
                client_id: clientId,
                scope: 'openid email profile',
                callback: () => {}
            });
            const btn = document.createElement('div');
            document.body.appendChild(btn);
            window.google.accounts.id.renderButton(btn, { type: 'standard' });
            btn.querySelector('[role="button"]') && btn.querySelector('[role="button"]').click();
            setTimeout(() => btn.remove(), 100);
        }
    });
}

function getGoogleIdToken(clientId) {
    return new Promise((resolve, reject) => {
        if (!window.google || !window.google.accounts) {
            loadGoogleScript().then(() => initAndPrompt(clientId, resolve, reject)).catch(reject);
        } else {
            initAndPrompt(clientId, resolve, reject);
        }
    });
}

export default {
    getGoogleIdToken
}
